/**
 * Etiquetas de UI para estado de mascota (API: ACTIVA | INACTIVA | FALLECIDA).
 * ACTIVA → "Viva" (no confundir con "activa" de cuenta).
 */
export function labelEstadoMascota(estado) {
  const m = { ACTIVA: 'Viva', INACTIVA: 'En recuerdos', FALLECIDA: 'Fallecida' }
  return m[estado] || estado || '—'
}
